import React from 'react';
import { MapPin, Truck, AlertCircle } from 'lucide-react';

const MapView = ({ loads = [], drivers = [] }) => {
  return (
    <div className="relative w-full h-full rounded-lg overflow-hidden bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900" data-testid="map-view-container">
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1761307234324-0c9eadb951de?crop=entropy&cs=srgb&fm=jpg&q=85')"
        }}
      />
      
      <div className="relative z-10 w-full h-full flex items-center justify-center">
        <div className="text-center space-y-4 p-8 glass-card rounded-xl max-w-md">
          <div className="flex justify-center gap-4 mb-4">
            <div className="p-3 rounded-lg bg-primary/15">
              <MapPin className="w-8 h-8 text-primary" />
            </div>
            <div className="p-3 rounded-lg bg-emerald-500/15">
              <Truck className="w-8 h-8 text-emerald-500" />
            </div>
          </div>
          
          <h3 className="text-xl font-bold font-heading text-foreground">Live Fleet Tracking</h3>
          <p className="text-sm text-muted-foreground">
            Tracking {loads.length} loads and {drivers.length} drivers
          </p>
          
          <div className="mt-6 space-y-2">
            <div className="flex items-center justify-between text-xs p-2 rounded bg-background/50">
              <span className="text-muted-foreground">Active Loads:</span>
              <span className="font-mono font-bold text-primary">{loads.length}</span>
            </div>
            <div className="flex items-center justify-between text-xs p-2 rounded bg-background/50">
              <span className="text-muted-foreground">Drivers Online:</span>
              <span className="font-mono font-bold text-emerald-500">{drivers.length}</span>
            </div>
          </div>
          
          <div className="mt-4 p-3 rounded-lg bg-blue-500/10 border border-blue-500/20">
            <div className="flex items-start gap-2">
              <AlertCircle className="w-4 h-4 text-blue-500 mt-0.5 flex-shrink-0" />
              <div className="text-left">
                <p className="text-xs text-blue-500 font-semibold mb-1">Map Ready</p>
                <p className="text-xs text-blue-500/80">
                  Google Maps will activate once billing propagation completes (typically 10-15 minutes).
                  All dispatch features are fully operational!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute top-4 right-4 space-y-2 z-10" data-testid="map-legend">
        <div className="glass-card p-3 space-y-2">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-primary"></div>
            <span className="text-xs text-muted-foreground">Pickup Locations</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-emerald-500"></div>
            <span className="text-xs text-muted-foreground">Drivers Available</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-amber-500"></div>
            <span className="text-xs text-muted-foreground">Drivers Assigned</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-4 left-4 z-10">
        <div className="glass-card p-3 space-x-4 flex items-center">
          <div className="flex items-center gap-2">
            <MapPin className="w-4 h-4 text-primary" />
            <span className="text-xs text-foreground font-mono">{loads.length} Loads</span>
          </div>
          <div className="flex items-center gap-2">
            <Truck className="w-4 h-4 text-emerald-500" />
            <span className="text-xs text-foreground font-mono">{drivers.length} Drivers</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapView;